MonitoringSynchroClientServeurController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    'PaginationService',
    'MonitoringSynchroService',
    'notification',
    'moment',
    '$window',
    'MassiaRightsService'
];

export default function MonitoringSynchroClientServeurController(
    $scope,
    $state,
    $stateParams,
    PaginationService,
    MonitoringSynchroService,
    notification,
    moment,
    $window,
    MassiaRightsService
) {
    let previousTableState;
    let customFilters = null;
    let isFirstLaunch = true;

    const vm = this;
    vm.domTab = [
        'Benne',
        'Chantiers',
        'Commandes',
        'Divers',
        'DocCE',
        'Lieu',
        'ModePaiement',
        'Normes',
        'OriDest',
        'Personnel',
        'Prestation',
        'Produits',
        'SiteClient',
        'SiteFourn',
        'SiteProd',
        'SiteTransp',
        'SiteUtil',
        'Societes',
        'TypeBascule',
        'Types',
        'Vehicule',
        'Dap'
    ];

    vm.moment = moment;
    vm.loading = false;
    vm.params = $stateParams;
    vm.state = $state;
    vm.monitoring = [];
    vm.slideWidth = '1200px';
    vm.slideMargin = {
        'margin-right': '0px',
        'transition-duration': '0.5s',
        'transition-animation': 'margin-right'
    };
    vm.loadMonitoring = loadMonitoring;
    vm.errorList = [];
    vm.popover = 'errorList.html';
    vm.itemsByPageOptions = [100, 500, 1000];
    vm.itemsByPage = vm.itemsByPageOptions[0];
    vm.activeJustified = 0;
    vm.sitesList = [];
    vm.domaineList = [];
    vm.searchingForm = {};
    vm.searchingForm.siteSelected = null;
    vm.searchingForm.domaineSelected = null;
    vm.searchingForm.stateSelected = null;
    vm.searchingForm.startDate = null;
    vm.searchingForm.endDate = null;
    vm.isSearchOngletOpen = true;
    vm.droitrelance = MassiaRightsService.userHasRight('monitoringsync', 'create', 'gestion');

    async function init() {
        localStorage.removeItem(vm.state.current.name);
    }

    init();

    async function loadMonitoring(tableState) {
        startLoading();
        if (tableState) {
            previousTableState = tableState;
        }

        let filters = PaginationService.getFilters(previousTableState);
        const sorts = PaginationService.getSorts(previousTableState);
        const pagination = PaginationService.getPagination(previousTableState);

        if (isFirstLaunch) {
            customFilters = setFirstLaunchDate();
            initFilters();
        }

        if (customFilters) {
            filters = [...filters, ...customFilters];
        } else {
            initFilters();
            filters = [...filters, ...customFilters];
        }

        vm.monitoring = [];
        try {
            const data = await MonitoringSynchroService.getMonitoringClientServeur(filters, sorts, pagination);

            vm.monitoring = data.items;
            if (isFirstLaunch) {
                if (vm.sites) {
                    vm.sitesList = vm.sites;
                }

                if (vm.domaines && vm.domTab) {
                    vm.domaineList = vm.domaines.filter((d) => vm.domTab.includes(d.code));
                }
                isFirstLaunch = false;
            }

            if (previousTableState) {
                PaginationService.setTableState(data.skip, data.take, data.total, previousTableState);
            }
        } catch (ex) {
            notification.error(ex.data);
        } finally {
            stopLoading();
        }
        isFirstLaunch = false;
    }

    $scope.getErrorList = (errorList) => {
        vm.errorList = errorList;
    };

    function startLoading() {
        vm.loading = true;
    }

    function stopLoading() {
        vm.loading = false;
    }

    $scope.search = () => {
        initFilters();
        loadMonitoring();
    };

    $scope.reset = () => {
        customFilters = [];
        loadMonitoring();
        vm.searchingForm.siteSelected = null;
        vm.searchingForm.domaineSelected = null;
        vm.searchingForm.stateSelected = null;
        vm.searchingForm.startDate = null;
        vm.searchingForm.endDate = null;
    };

    function getFormatedDate(date) {
        const dateArray = date.split('/');
        const formatedDate = new Date(`${dateArray[2]}`, dateArray[1], dateArray[0]);
        formatedDate.setMonth(formatedDate.getMonth());
        formatedDate.setHours(formatedDate.getHours() + 1);
        return formatedDate.toISOString();
    }

    $scope.print = async () => {
        try {
            const ajdhui = Date.now();
            const fileName = 'Liste_monitoring_client_vers_serveur' + vm.moment(ajdhui).format('DDMMYY');
            const sorts = PaginationService.getSorts(previousTableState);
            const resultat = await MonitoringSynchroService.printClientServeur(customFilters, sorts);
            const data = resultat.data;
            const status = resultat.status;
            let headers = resultat.headers;

            headers = headers();

            const contentType = headers['content-type'];

            const linkElement = document.createElement('a');
            try {
                const blob = new Blob([data], { type: contentType + ';charset=UTF-8' });
                const url = window.URL.createObjectURL(blob);
                linkElement.setAttribute('href', url);
                linkElement.setAttribute('download', fileName + '.xlsx');

                const clickEvent = new MouseEvent('click', {
                    view: window,
                    bubbles: true,
                    cancelable: false
                });
                linkElement.dispatchEvent(clickEvent);
            } catch (ex) {
            } finally {
            }
            return true;
        } catch (ex) {
            notification.error(ex.data);
            return false;
        }
    };

    $scope.getSynchroXML = (o) => {
        const cheminXml = o.synchroReussie ? o.cheminArchive : o.cheminRejet;
        return $window.open(__server + cheminXml, '_blank');
    };

    $scope.moveFailedSynchroXML = async (o) => {
        try {
            const fixtion = o.nomFichier.split('.');
            await MonitoringSynchroService.moveFailedSynchroXML(fixtion[0], fixtion[1], o.id);
            o.createdXML = true;
            notification.success('MONITORING_SYNCHRO.RELANCEENCOURS');
        } catch (err) {
            console.error(err);
            notification.error('MONITORING_SYNCHRO.RELANCEECHEC');
        }
    };

    function setFirstLaunchDate() {
        // pour le premier lancement
        customFilters = [];
        // recuperation de la date du jour
        const date = new Date();
        const d = vm.moment(date).format('DD/MM/YYYY');
        vm.searchingForm.startDate = d;
        vm.searchingForm.endDate = d;

        // ajout au custom filter date debut et date de fin
        let filter = {};
        filter.criterion = 'dateDemandeSynchro';
        filter.type = 'Ge';
        filter.value = getFormatedDate(d);
        customFilters.push(filter);

        filter = {};
        filter.criterion = 'dateDemandeSynchro';
        filter.type = 'Lt';
        filter.value = getFormatedDate(d);
        customFilters.push(filter);

        return customFilters;
    }

    function initFilters() {
        customFilters = [];
        const options = vm.searchingForm;

        if (options.siteSelected) {
            const filter = {};
            filter.criterion = 'siteEmmetteur.id';
            filter.type = 'Eq';
            filter.value = options.siteSelected;
            customFilters.push(filter);
        }
        if (options.startDate) {
            const filter = {};
            filter.criterion = 'dateEnvoiFichier';
            filter.type = 'Ge';
            filter.value = getFormatedDate(options.startDate);
            customFilters.push(filter);
        }
        if (options.endDate) {
            const filter = {};
            filter.criterion = 'dateEnvoiFichier';
            filter.type = 'Lt';
            const d = new Date(getFormatedDate(options.endDate));
            d.setDate(d.getDate() + 1);
            filter.value = d.toISOString();
            customFilters.push(filter);
        }
        if (options.domaineSelected) {
            const filter = {};
            filter.criterion = 'domainFichier.id';
            filter.type = 'Eq';
            filter.value = options.domaineSelected;
            customFilters.push(filter);
        }
        if (typeof options.stateSelected === 'boolean' || options.stateSelected === '###') {
            const filter = {};
            filter.criterion = 'synchroSuccess';
            filter.type = 'Eq';
            filter.value = options.stateSelected;
            customFilters.push(filter);
        }
    }
}
